<script>
  import currentUser from '../../stores/auth';
  import createProjectStore from '../../stores/project'
  import createProjectMapsStore from '../../stores/project-maps'
  import {Link} from "svelte-routing";
  import Message from '../../components/Message.svelte'
  import ProjectHeader from '../../components/ProjectHeader.svelte'
  import ProjectDesc from '../../components/ProjectDesc.svelte'
  import MapsList from '../../components/Admin/MapsList.svelte'
  import MapAdd from '../../components/Admin/MapAdd.svelte'
  import Loader from '../../components/Loader.svelte'

  export let id;

  let currentComponent = MapsList;

  $: project = id ? createProjectStore(id) : null;
  $: maps = id ? createProjectMapsStore(id) : null;

  $: projectLoading = project ? project.loading : null;
  $: mapsLoading = maps ? maps.loading : null;

  $: loading = $projectLoading || $mapsLoading ? true : false;

  $: currentComponentProps = {project: $project, maps: $maps, loading}
</script>

<section class="nes-container is-dark is-rounded">
  {#if $currentUser}
    {#if loading}
      <Loader text="Loading..." />
    {:else if project && $project}
      <ProjectHeader project={$project}/>
      <ProjectDesc project={$project}/>

      <div class="main-actions" class:hide={currentComponent !== MapsList}>
        <button class="nes-btn is-primary" on:click={() => currentComponent = MapAdd}>Add a new map</button>
      </div>

      <svelte:component this={currentComponent} {...currentComponentProps}
                        on:add={() => currentComponent = MapsList}
                        on:cancel={() => currentComponent = MapsList}
      />
    {:else}
      <section class="message-list">
        <Message>
          It looks like the selected project does not exist.
          Back to
          <Link to="/projects">All Projects</Link>
          page.
        </Message>
      </section>
    {/if}
  {:else}
    <p class="nes-text is-error">
      This page is available for authenticated users only. Please log in.
    </p>
  {/if}
</section>

<style>
    .nes-container {
        min-height: 10rem;
    }

    .main-actions {
        margin-bottom: 1rem;
    }

    .hide {
        display: none;
    }
</style>